export default __webpack_public_path__ + "static/agency_x-ea1377185387e2320fcd1d6ad2469b1d.png";